export const dashboardMixin = {
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        corporateInfo() {
            return this.userInfo?.corporate;
        },
        corporateBrandColor() {
            if (this.corporateInfo?.banner_color) {
                const color = this.corporateInfo.banner_color;
                return (typeof color === 'string') ? color : undefined;
            } else {
                return undefined;
            }
        },
        corporateLogo() {
            if (this.corporateInfo?.profile_pic) {
                return this.corporateInfo.profile_pic;
            } else {
                return null;
            }
        },
        corporateName() {
            if (this.corporateInfo?.name) {
                return this.corporateInfo.name;
            } else {
                return null;
            }
        },
        corporateHomePageRoute() {
            if (this.corporateInfo?.redirect_url) {
                let redirectUrl = this.corporateInfo.redirect_url;
                return {
                    path: `/${redirectUrl}`
                };
            } else {
                return null;
            }
        }
    },
    methods: {
    }
}